import { useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./SamsungCall.module.scss";
import classnames from "classnames"
import KeyPad from "./keypad/KeyPad";
import CallLog from "./call-log/CallLog";
import { CONTACTS } from "../../contacts/Contact";
import Contacts from "./contacts/Contacts";
import BasicContactInfo from "./basic-contact-info/BasicContactInfo";

interface SamsungCallProps {
    activeWindow: "keypad" | "log" | "contacts";
}

const SamsungCall = ({ activeWindow }: SamsungCallProps) => {

    const WindowTitles = {
    }


    const [number, setNumber] = useState("")
    const [activeId, setActiveId] = useState("")
    const [activeContact, setActiveContact] = useState({
        label: "Priyansh datyal",
        designation: "Software Development Engineer",
        phone: "(091) 70187-*****",
        work: "priyansh.sk80@gmail.com",
        facetime: "",
        birthday: "June 15",
        home: "District Hamirpur, Himachal Pradesh, India",
        pfp: "https://firebasestorage.googleapis.com/v0/b/priyanshdatyal-me.appspot.com/o/website%20resources%2Fportfolio_profile_picture.webp?alt=media&token=8396fd2a-7b6e-452d-866b-b0aecf5077f0"
    })
    const [activeState, setActiveState] = useState<"keypad" | "log" | "contacts">(activeWindow)

    const handleContactClick = (id: string) => {
        setActiveId(id)
    }


    const handleBackClick = () => {
        setActiveId("")
    }


    interface WindowOptionTypes{
        "keypad":WindowTypes;
        "log" :WindowTypes;
        "contacts":WindowTypes;
    }

    interface WindowTypes{
        id: "keypad" | "log" | "contacts";
        label: string;
        title: string
    }

    const windowOption :WindowOptionTypes= {
        "keypad": {
            id: "keypad",
            label: "Keypad",
            title: ""
        },
        "log": {
            id: "log",
            label: "Recents",
            title: "Phone"
        },
        "contacts": {
            id: "contacts",
            label: "Contacts",
            title: "Phone"
        },
        
    }

    const getScreen = () => {
        switch (activeState) {
            case "contacts": return <Contacts contacts={CONTACTS} handleContactClick={handleContactClick} />;
            case "log": return <CallLog />
        }
    }

    return (
        <BaseMobileAppContainer
            appId={activeWindow==="keypad"?APP_KEY_IDS.MOBILE_PHONE:APP_KEY_IDS.MOBILE_CONTACTS}
            title={activeState==="keypad"?"" :"Phone"}
            MainScreen={
                activeState === "keypad"
                    ?
                    <div className={Styles.container}>
                        <div className={Styles.screen}>
                            <KeyPad number={number} onClickKeypad={(number: string) => setNumber(number)} />;
                        </div>
                        <div className={Styles.option_selection}>
                            {
                                Object.values(windowOption).map((option: any) => {
                                    return (
                                        <div className={Styles.option_container} key={option.id}>
                                            <div key={option.id} className={classnames(Styles.option, activeState === option.id && Styles.active)} onClick={() => { setActiveState(option.id) }}>
                                                {option.label}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    :
                    <BasicContactInfo
                        label={activeContact.label}
                        phone={activeContact.phone}
                        work={activeContact.work}
                        facetime={activeContact.facetime}
                        birthday={activeContact.birthday}
                        home={activeContact.home}
                        pfp={activeContact.pfp}
                        designation={activeContact.designation}
                    />
            }
            MainMenuOptions={
                <div className={Styles.option_screen}>
                    {getScreen()}
                    <div className={Styles.option_selection}>
                        {
                            Object.values(windowOption).map((option: any) => {
                                return (
                                    <div className={Styles.option_container} key={option.id}>
                                        <div key={option.id} className={classnames(Styles.option, activeState === option.id && Styles.active)} onClick={() => { setActiveState(option.id) }}>
                                            {option.label}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }
            isMainScreenActive={activeState === "keypad" || !!activeId}
            handleBackClick={activeState === "contacts" ? handleBackClick : undefined}
        />
    )
}

export default SamsungCall
